import { useResolvedPath, useLocation } from 'react-router-dom';
export function useIsGroupActive(children, isActive) {
  const {
    pathname
  } = useLocation();

  if (isActive) {
    return isActive.test(pathname);
  }

  return Boolean(children.length && children.some(c => {
    var _c$href;

    return c.to ? pathname.endsWith(c.to) : (_c$href = c.href) === null || _c$href === void 0 ? void 0 : _c$href.endsWith(pathname);
  }));
}
export function useIsActive(path) {
  return useResolvedPath(path).pathname.endsWith(useLocation().pathname);
}